import { render, staticRenderFns } from "./TermAndCondition.vue?vue&type=template&id=2bde0e3f&scoped=true"
import script from "./TermAndCondition.vue?vue&type=script&lang=js"
export * from "./TermAndCondition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bde0e3f",
  null
  
)

export default component.exports